import {doc, getDoc} from 'firebase/firestore';
import {db} from '../config';

const COLLECTION = 'pages';

export const getPageContent = async (pageId) => {
  const ref = doc(db, COLLECTION, pageId);
  const snap = await getDoc(ref);
  if (!snap.exists()) {
    throw new Error(`No content found for page: ${pageId}`);
  }
  return snap.data();
};
